import React from 'react';
import ProductLineDisclaimerText from './ProductLineDisclaimer';
import useJSSComponentContext from '../../hooks/useJSSComponentContext';

const DisclaimerMap = () => {
  const { componentName, DisclaimerComponent, fields } = useJSSComponentContext();

  if (componentName && DisclaimerComponent) return <DisclaimerComponent fields={fields} />;

  return <ProductLineDisclaimerText />;
};

export default DisclaimerMap;
